<template>
  <b-card-code
    title="Animation"
  >
    <b-card-text>
      <span>Add animation to changes using </span>
      <code>transition-group</code>
      <span>.</span>
    </b-card-text>

    <h6 class="text-primary font-weight-bold mb-2">
      People Group
    </h6>
    <!-- draggable -->
    {{ list }}
    <draggable
      v-model="list"
      class="list-group list-group-flush cursor-move"
      tag="ul"
    >
      <transition-group
        type="transition"
        name="flip-list"
      >
        <b-list-group-item
          v-for="listItem in list"
          :key="listItem.email"
          class="movablelistitems mb-1"
          tag="li"
        >
          <a :href="'mailto:' + listItem.email">{{ listItem.email }}</a>
          <case-statements />
        </b-list-group-item>
      </transition-group>
    </draggable>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BListGroupItem,
  // BAvatar,
  BCardText,
} from 'bootstrap-vue'
import draggable from 'vuedraggable'
import CaseStatements from './details/childcomponents/CaseStatements.vue'
// import Prism from 'vue-prism-component'
// import 'prismjs'
// import 'prismjs/themes/prism-tomorrow.css'

export default {
  components: {
    BCardCode,
    draggable,
    BListGroupItem,
    // BAvatar,
    BCardText,
    CaseStatements,
    // Prism,
  },
  data() {
    return {
      list: [{
        name: 'Paz Joya',
        email: 'girliness@spotlike.co.uk',
      },
      {
        name: 'Sunshine Cose',
        email: 'executrixship@equisized.edu',
      },
      {
        name: 'Alba Dobbin',
        email: 'bidding@demibob.or',
      },
      {
        name: 'Marlin Hinchee',
        email: 'preholding@scuffly.co.uk',
      },
      {
        name: 'Leia Atienza',
        email: 'unmeasurableness@interlamellar.co.uk',
      },
      {
        name: 'Lashawna Vaudrainm',
        email: 'soaking@khubber.com',
      },
      {
        name: 'Liliana Henscheid',
        email: 'lecideine@turndown.org',
      },
      {
        name: 'Keven Kolter',
        email: 'nontenure@anglicanum.co.uk',
      },
      ],
    }
  },
}
</script>

<style>
.list-group-item {
  transition: all 1s
}
</style>

<style lang="scss" scoped>
.list-group-item{
  animation-name: shake;
  animation-duration: .22s;
  animation-iteration-count: infinite;
  transition: all 1s ease;
  &:nth-child(even){
    animation-name: shakeeven;
  }
}
@keyframes shake {
  0% {
    transform: translate3d(-4px, 0, 0);
  }
  50% {
    transform: translate3d(4px, 0, 0);
  }
  100% {
    transform: translate3d(-4px, 0, 0);
  }
}
@keyframes shakeeven {
  0% {
    transform: translate3d(4px, 0, 0);
  }
  50% {
    transform: translate3d(-4px, 0, 0);
  }
  100% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>
